function MegaMenuFullscreenFactory(container) {
  class MegaMenuFullscreen {
    constructor(container) {
      this.megaMenuFullscreen = container;
      this.filterTogglers = document.querySelectorAll(
        `[data-toggle-mega-menu="${this.megaMenuFullscreen.getAttribute(
          "data-mega-menu"
        )}"]`
      );
      this._outsideClickListener = null;
      this._hoverOutTimer = null;
      this._isHoveringMenu = false;
      this.tl;
      this._init();
    }

    _init() {
      this._setEvents();
    }

    _setEvents() {
      for (const filterToggler of this.filterTogglers) {
        const triggerMode = filterToggler.getAttribute("trigger");
        const isHover = triggerMode === "hover" && window.matchMedia("(pointer: fine)").matches;

        filterToggler.addEventListener("click", (event) => {
          event.stopPropagation();
          if (isHover) {
            // On hover mode, click navigates to the URL if available
            const url = filterToggler.querySelector("summary")?.getAttribute("data-url")
              || filterToggler.querySelector("[data-url]")?.getAttribute("data-url");
            if (url) {
              window.location.href = url;
            }
            return;
          }
          this._toggleMenu(filterToggler);
        });

        if (isHover) {
          filterToggler.addEventListener("mouseenter", () => {
            clearTimeout(this._hoverOutTimer);
            if (!this.megaMenuFullscreen.classList.contains("--active")) {
              this._closeOtherMenus(filterToggler);
              this._fadeInMenu();
            }
          });

          filterToggler.addEventListener("mouseleave", () => {
            this._hoverOutTimer = setTimeout(() => {
              if (!this._isHoveringMenu) {
                this._fadeOutMenu();
              }
            }, 300);
          });

          this.megaMenuFullscreen.addEventListener("mouseenter", () => {
            clearTimeout(this._hoverOutTimer);
            this._isHoveringMenu = true;
          });

          this.megaMenuFullscreen.addEventListener("mouseleave", () => {
            this._isHoveringMenu = false;
            this._hoverOutTimer = setTimeout(() => {
              this._fadeOutMenu();
            }, 300);
          });
        }
      }
    }

    _closeOtherMenus(filterToggler) {
      let megamenuTarget = filterToggler.getAttribute("data-toggle-mega-menu");
      for (const mega_menu of document.querySelectorAll("[data-mega-menu].--active")) {
        let megamenuReference = mega_menu.getAttribute("data-mega-menu");
        if (megamenuTarget !== megamenuReference) {
          mega_menu.classList.remove("--active");
          const toggler = document.querySelector(`[data-toggle-mega-menu="${megamenuReference}"]`);
          if (toggler) toggler.removeAttribute("open");
        }
      }
    }

    _toggleMenu(filterToggler) {
      this._closeOtherMenus(filterToggler);
      if (this.megaMenuFullscreen.classList.contains("--active")) {
        this._fadeOutMenu();
      } else {
        this._fadeInMenu();
      }
    }

    _fadeInMenu() {
      this.tl = gsap.timeline();
      this.megaMenuFullscreen.classList.add("--active");

      // Animate the fade-in with GSAP
      this.tl.fromTo(
        this.megaMenuFullscreen,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.15,
        }
      );

      this.tl.fromTo(
        this.megaMenuFullscreen.querySelectorAll(
          ".mega-menu__nav > li, .navigation-promo__wrapper"
        ),
        {
          opacity: 0,
          y: -10,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.15,
          stagger: 0.1,
        }
      );
      // Enable click outside detection
      this._enableClickOutside();
    }

    _fadeOutMenu() {
      if (!this.tl) {
        this.tl = gsap.timeline();
      }
      // Animate the fade-out with GSAP
      // Reverse the timeline and wait for the animation to complete
      this.tl.eventCallback("onReverseComplete", () => {
        setTimeout(() => {
          this.megaMenuFullscreen.classList.remove("--active");
          this._disableClickOutside(); // Remove the click outside listener after closing
        }, 150);
      });
      this.tl.eventCallback("onComplete", () => {
        setTimeout(() => {
          this.megaMenuFullscreen.classList.remove("--active");
          this._disableClickOutside(); // Remove the click outside listener after closing
        }, 150);
      });
      // this.tl.reverse();
      this.tl.to(this.megaMenuFullscreen, {
        opacity: 0,
        duration: 0.2,
      });
    }

    _enableClickOutside() {
      // Add click outside detection
      this._outsideClickListener = this._onClickOutside(
        this.megaMenuFullscreen,
        () => {
          this._fadeOutMenu(); // Close the menu when clicking outside
        }
      );
    }

    _disableClickOutside() {
      // Remove the outside click listener when the menu is closed
      if (this._outsideClickListener) {
        this._outsideClickListener(); // Call the function returned by _onClickOutside to remove listener
        this._outsideClickListener = null;
      }
    }

    _onClickOutside(element, callback) {
      // Detect clicks outside of the specified element
      function handleClickOutside(event) {
        if (!element.contains(event.target)) {
          callback(); // Trigger callback if clicked outside
        }
      }

      // Attach the event listener to the document
      document.addEventListener("click", handleClickOutside);

      // Return a function to remove the event listener
      return function removeClickListener() {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }

  return new MegaMenuFullscreen(container);
}
